import { Component, OnInit } from '@angular/core';
import { ParametreGeneral } from '../../core/model/ParametreGeneral';
import { Router, ActivatedRoute } from '@angular/router';
import { ParametreGeneralService } from '../../core/service/parametre-general.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from "rxjs/operators";

@Component({
  selector: "app-edit-parametre-general",
  templateUrl: "./edit-parametre-general.component.html",
  styleUrls: ["./edit-parametre-general.component.scss"]
})
export class EditParametreGeneralComponent implements OnInit {
  parametreGeneral: ParametreGeneral;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _parametreGeneralService: ParametreGeneralService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {}

  createForm(parametreGeneral: ParametreGeneral) {
    this.form2 = this.fb.group({

      codeParametre: [
        parametreGeneral.codeParametre,
        Validators.compose([Validators.required])
      ],
      libelleParametre: [
        parametreGeneral.libelleParametre,
        Validators.compose([Validators.required])
      ],
      valeurParametre: [
        parametreGeneral.valeurParametre,
        Validators.compose([Validators.required])
      ],
      typeParametre: [
        parametreGeneral.typeParametre,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.createForm(this.parametreGeneral);

  }

  save(): void {
    this.pressButton = true;
    const id = this.parametreGeneral.id;
    this.parametreGeneral = { ...this.form2.value, id };

    this._parametreGeneralService
      .update(this.parametreGeneral)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close(this.parametreGeneral);
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
